export default class AppError extends Error {
  constructor(message, ...params) {
    super(...params);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, Error);
    }
    this.message = message;
  }
}
